import React from 'react';
import { Typography } from '@material-ui/core';


export default function UltimaVez({auditoria,onlyString}) {
    const diaHoy = new Date();
    let fecha1 = diaHoy.getTime() - (3600000 * 3);
    //extraigo la fecha ingresada en el registro
    let auxDate =  Date.parse(auditoria);
    let fechaUltimaVista = new Date(auxDate);
    let fecha2 = fechaUltimaVista.getTime();
    let fecha = (fecha1 - fecha2) / 1000;
    let mensaje;
    let minutos;
    let horas;
    let dias;
    if (fecha < 60) {
        let segundos = Math.round(fecha)
        if (segundos<0) segundos = 0;
        
        mensaje= `Hace ${ segundos } segundos`
    }
    if (fecha > 60 && fecha < 3600) {
        minutos = Math.round(fecha / 60);
        mensaje = `Hace ${minutos} minutos`
    }

    if (fecha > 3600 && fecha < 86400) {
        horas = Math.round(fecha / 3600);
        mensaje = `Hace ${horas} horas`
    }

    if (fecha > 86400) {
        dias = Math.round(fecha / 86400);
        if (dias>14){
            let semanas = Math.round(dias / 7);
            mensaje = `Hace ${semanas} semanas`
        }else if (dias>7){
            mensaje = `Hace mas de una semana`
        } else if (dias===7){
            mensaje = `Hace una semana`
        } else if (dias<7){
        mensaje = `Hace ${ dias } dias`
        } 
    }

if (onlyString){
    return mensaje;
}


return (
    <div  style={{height:"100%", display: "flex", flexDirection:"column", alignItem:"center", justifyContent:"space-between", alignContent:"center"}}>
        {auditoria &&
                <Typography id="vertical-slider" align="center">
                    <p style={{margin:"5px"}}>Último dato:</p>
                    <p style={{margin:"0px"}}>{mensaje}</p>
                </Typography>
            }
    </div>
);
}